var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSinoComNotificacao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#E5FFEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 36C24.8954 36 24 35.1046 24 34H28C28 35.1046 27.1046 36 26 36ZM34 33H18V31L20 30V24.5C19.9473 23.0891 20.2659 21.6891 20.924 20.44C21.579 19.2815 22.6987 18.4589 24 18.18V16H27.646C26.3464 17.4524 26.1295 19.5764 27.1087 21.2615C28.0879 22.9467 30.0406 23.8099 31.946 23.4C31.981 23.757 31.998 24.127 31.998 24.5V30L33.998 31V33H34Z",
    fill: "#1F9833"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0096 19.1667C28.098 20.7545 29.41 21.9975 31.0003 22C31.2291 22 31.4573 21.9742 31.6803 21.923C33.2298 21.565 34.2307 20.0601 33.9618 18.4927C33.6929 16.9253 32.2476 15.8401 30.6674 16.019C29.0872 16.198 27.9212 17.5789 28.0096 19.1667Z",
    fill: "#DB0A3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinoComNotificacao);
export default __webpack_public_path__ + "static/media/sino-com-notificacao.1042c7ac.svg";
export { ForwardRef as ReactComponent };